"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@material-ui/core");
var material_kit_pro_react_1 = require("../../../assets/jss/material-kit-pro-react");
var styles = function (theme) {
    return (0, core_1.makeStyles)({
        root: __assign(__assign({}, material_kit_pro_react_1.container), { display: 'flex', flex: 1, flexDirection: 'column' }),
        field: {
            width: '100%',
            marginTop: theme.spacing(),
            marginBottom: theme.spacing(),
            paddingBottom: theme.spacing()
        },
        bottomSpacing: {
            marginBottom: theme.spacing(3)
        },
        buttonsContainer: {
            display: 'flex',
            justifyContent: 'center',
            marginBottom: theme.spacing(2)
        },
        buttonSpacing: {
            marginRight: theme.spacing(),
            marginLeft: theme.spacing()
        },
        cancelButtonSpacing: {
            marginRight: theme.spacing(),
            marginLeft: theme.spacing(),
            border: 'none'
        }
    });
};
exports.default = styles;
//# sourceMappingURL=styles.js.map